import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-121" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-122" data-mp="1dxjkfkoq7bg7">
        <div className="text-center" data-id="element-123" data-mp="1dunlpu520iqp">
          <span className="inline-flex items-center gap-2 rounded-full bg-leafSoft px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-leafDark" data-id="element-124" data-mp="2bkiedno1a5ae">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-125" data-mp="26jb5tme2h22o" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-navy sm:text-4xl" data-id="element-126" data-mp="1wn87krmc5nl0">
            The {totalVolumes} comprehensive volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-127" data-mp="q4jgjic7waxl">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-line bg-white shadow-card" data-id="element-128" data-mp="1ivryulz6j34s" data-mpi={index}>
                <div className="flex items-center gap-4 bg-navy px-6 py-5" data-id="element-129" data-mp="14vh7lhtyjmj3">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-leaf text-white" data-id="element-130" data-mp="14xk8iwwnf02l">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-131" data-mp="v5nwsj1n3bfw" />
                  </span>
                  <div data-id="element-132" data-mp="v3beg4ryyz2b">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-solar" data-id="element-133" data-mp="h5d4rcolfqt5">
                      Volume {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-white" data-id="element-134" data-mp="l9b1xhucyrjk">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-135" data-mp="2j2dsujuaczki">
                  <p className="font-semibold text-navy" data-id="element-136" data-mp="2e4c3xia6i614">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-leafDark" data-id="element-137" data-mp="2e29a0n5wnsr4">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-138" data-mp="36s85b0ap0m48">{module.context}</p>

                  <ul className="mt-5 grid flex-1 gap-2" data-id="element-139" data-mp="31upvl7ouq2v6">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-navy" data-id="element-140" data-mp="2wwwqyj375gx0">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-leaf" aria-hidden="true" data-id="element-141" data-mp="2ssytectise62" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-leaf bg-leafSoft p-4 text-sm leading-relaxed text-navy" data-id="element-142" data-mp="1hg61n20qbpq0">
                    <b className="font-extrabold" data-id="element-143" data-mp="xm7p8p447qq">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl border border-line bg-mist px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-144" data-mp="an5s4ish49np">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-muted" data-id="element-145" data-mp="fomnjys6v3ww">Main collection</p>
          <p className="font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-146" data-mp="kng4602rvb1a">
            {totalVolumes} premium volumes <span className="mx-2 text-leaf" data-id="element-147" data-mp="tmbdhl14518t">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}